import ApplicationController from './application_controller'

// Submits the public lead form with fetch so the visitor stays on the catalog page.
export default class extends ApplicationController {
  static targets = ['form', 'error', 'success']

  async submit (event) {
    event.preventDefault()

    this.errorTarget.hidden = true
    this.successTarget.hidden = true

    const submitButton = this.formTarget.querySelector('[type="submit"]')
    if (submitButton) submitButton.disabled = true

    try {
      const response = await fetch(this.formTarget.action, {
        method: 'POST',
        body: new FormData(this.formTarget),
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })

      if (response.ok) {
        this.formTarget.reset()
        this.successTarget.hidden = false
      } else {
        this.errorTarget.hidden = false
      }
    } catch (_error) {
      this.errorTarget.hidden = false
    } finally {
      if (submitButton) submitButton.disabled = false
    }
  }
}
